var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"tab-card centered-div-wrapper"},[_c('div',{staticClass:"centered-div text-center"},[_c('h1',{staticClass:"mb-4"},[_vm._v("Berechnung")]),_c('LoadingAnimation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }